/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useContext } from 'react'
import { PaginationContext } from './PaginationProvider'
import { Text, TextProps } from '@mantine/core'

export type PaginationInfoProps = TextProps

function PaginationInfo (props: PaginationInfoProps) {
  const { ...others } = props
  const {
    limit,
    offset,
    totalElements
  } = useContext(PaginationContext)

  return (
    <Text
      size="sm"
      c="dimmed"
      {...others}
    >
      {totalElements > 0 ? offset + 1 : 0}
      -
      {Math.min(totalElements, offset + limit)}
      &nbsp;
      /
      &nbsp;
      {totalElements}
    </Text>
  )
}

export default PaginationInfo
